var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-nav"},[(!_vm.urlList.includes(_vm.$route.path))?_c('div',{staticClass:"back"},[_c('img',{attrs:{"src":require("@/assets/back.png")},on:{"click":function($event){return _vm.back()}}}),_c('span',{on:{"click":function($event){return _vm.back()}}},[_vm._v("返回")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }